<div class="shop-infowindow">
	
	<img class="shop-infowindow-image" ng-src="{{::markerProperties.imageUrl}}" alt="{{markerProperties.name}}">
	
	<h1 class="shop-infowindow-name">{{markerProperties.name}}</h1>
	
	<p class="shop-infowindow-description" ng-bind-html="markerProperties.description"></p>
	
	<div class="shop-infowindow-clear"></div>
	
	<div class="shop-infowindow-spacer"></div>
	
	<p class="shop-infowindow-opened-now"><span class="fa fa-clock-o"></span>&nbsp;Azi:&nbsp;<span class="shop-infowindow-light-text shop-infowindow-status"><b>{{markerProperties.todaysProgram}}</b></span></p>
	
	<p class="shop-infowindow-distance" ng-if="markerProperties.distance"><span class="fa fa-map-marker fa-3"></span>&nbsp;Distan&#539;a:&nbsp;<span class="shop-infowindow-light-text">{{markerProperties.distance}}</span></p>
	
	<div class="shop-infowindow-directions">
		<a role="button" class="btn btn-important shop-infowindow-directions-btn" href="javascript:void(0);" target="_blank" ng-href="{{markerProperties.directionsUrl}}">Vezi direc&#539;ii</a>
	</div>
	
	<a role="button" class="btn shop-infowindow-details-btn" href="javascript:void(0);" target="_blank" ng-show="markerProperties.openShopDetailsUrlInNewWindow" ng-href="{{markerProperties.shopUrl}}">Vezi detalii</a>
	
	<a role="button" class="btn shop-infowindow-details-btn" href="javascript:void(0);" target="_self" ng-show="!markerProperties.openShopDetailsUrlInNewWindow" ng-click="goToShopDetailsPage(markerProperties.district, markerProperties.city, markerProperties.shopUrl, markerProperties.pos)">Vezi detalii</a>
</div>